import React, { useState } from 'react';
import { LeadershipMember, leadershipData } from '../../data/Leadership';
import './Leadership.styles.scss';
import Card from '../Card/Card';
import Modal from '../Modal/Modal';
import { Box, Typography } from '@mui/material';

const Leadership: React.FC = () => {
  const [selectedLeader, setSelectedLeader] = useState<LeadershipMember | null>(
    null
  );

  const handleOpenModal = (leader: LeadershipMember) => {
    setSelectedLeader(leader);
  };

  const handleCloseModal = () => {
    setSelectedLeader(null);
  };

  return (
    <div className="card-group card-max-row-4 leadership-wrapper">
      {leadershipData.map((leader) => {
        const isTruncated = leader.summary.length > 150;
        const truncatedHelper = isTruncated
          ? `${leader.summary.substring(0, 150)}...`
          : leader.summary;

        return (
          <Card
            key={leader.id}
            headline={leader.name}
            subhead={leader.title}
            helper={
              isTruncated ? `${truncatedHelper} Read More` : truncatedHelper
            }
            onClickHelper={
              isTruncated ? () => handleOpenModal(leader) : undefined
            }
            onImageClick={() => handleOpenModal(leader)}
            className="action-on-view action-fade-in"
          />
        );
      })}
      {selectedLeader && (
        <Modal open={!!selectedLeader} onClose={handleCloseModal}>
          <Box className="modal-title-container">
            <Box className="modal-title-subtitle">
              <Typography className="modal-title">
                {selectedLeader.name}
              </Typography>
              <Typography className="modal-subtitle">
                {selectedLeader.title}
              </Typography>
            </Box>
          </Box>
          <Typography className="modal-content">
            {selectedLeader.summary}
          </Typography>
        </Modal>
      )}
    </div>
  );
};

export default Leadership;
